module.exports = __webpack_public_path__ + "static/media/Avatars_Male-24.03b0da84.png";